export const DIMENSION = {
  Desktop: 'desktop',
  Tablet: 'tablet',
  Mobile: 'mobile',
};

export const LAYOUT = {
  Fluid: 'fluid',
  Boxed: 'boxed',
};

export const RADIUS = {
  Rounded: 'rounded',
  Standard: 'standard',
  Flat: 'flat',
};

export const THEME_COLOR = {
  LightBlue: 'light-blue',
  DarkBlue: 'dark-blue',
  LightRed: 'light-red',
  DarkRed: 'dark-red',
  LightGreen: 'light-green',
  DarkGreen: 'dark-green',
  LightPurple: 'light-purple',
  DarkPurple: 'dark-purple',
  LightPink: 'light-pink',
  DarkPink: 'dark-pink',
};

export const NAV_COLOR = {
  Default: 'default',
  Light: 'light',
  Dark: 'dark',
};
export const MENU_PLACEMENT = {
  Vertical: 'vertical',
  Horizontal: 'horizontal',
};
export const MENU_BEHAVIOUR = {
  Pinned: 'pinned',
  Unpinned: 'unpinned',
};

export const USER_ROLE = {
  Cliente: '99',
  Fornitore: '80',
  Spedizioniere: '60',
  Agente: '98',
  NotaSpese: '65',
  Bi: 'bi',
};

export const CONTRACT_TYPES = {
  CHIUSO: {
    title: 'Closed',
    formula(f, t) {
      const oggi = Date.now();
      const from = new Date(f?.split('/').reverse().join('-'));
      const to = new Date(t?.split('/').reverse().join('-'));

      return oggi > to;
    },
  },

  TOTALE: {
    title: 'All',
    formula() {
      return true;
    },
  },

  APERTO: {
    title: 'Current',
    formula(f, t) {
      const oggi = Date.now();
      const from = new Date(f?.split('/').reverse().join('-'));
      const to = new Date(t?.split('/').reverse().join('-'));
      return from <= oggi && oggi <= to;
    },
  },
};
